var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_Right",
    d: "M11.6815 10.2302L1.88051 0.766158C1.45045 0.351794 0.753688 0.351794 0.322543 0.766158C-0.107516 1.18052 -0.107516 1.85356 0.322543 2.26792L9.34609 10.981L0.323631 19.6941C-0.106427 20.1085 -0.106427 20.7815 0.323631 21.1969C0.753691 21.6113 1.45154 21.6113 1.8816 21.1969L11.6825 11.733C12.106 11.3229 12.106 10.6393 11.6815 10.2302Z",
    fill: "#730BDB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrRight);
export default __webpack_public_path__ + "static/media/arr-right.77cf39aec889920cc183714b31d26c32.svg";
export { ForwardRef as ReactComponent };